define(["underscore","bluebird","urijs","@bingads-webui/js-data-rest","@bingads-webui/url-util","@bingads-webui-clientcenter/restful-service"], function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__224__, __WEBPACK_EXTERNAL_MODULE__225__, __WEBPACK_EXTERNAL_MODULE__226__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 221);
/******/ })
/************************************************************************/
/******/ ({

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(222);


/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  GetJsDataInfo: true
};
Object.defineProperty(exports, "GetJsDataInfo", {
  enumerable: true,
  get: function get() {
    return _index.GetJsDataInfo;
  }
});

var _index = __webpack_require__(223);

var _utils = __webpack_require__(228);

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetJsDataInfo = GetJsDataInfo;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _urijs = _interopRequireDefault(__webpack_require__(36));

var _jsDataRest = __webpack_require__(224);

var _urlUtil = __webpack_require__(225);

var _restfulService = _interopRequireDefault(__webpack_require__(226));

var _staticResource = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Create RestfulService with given options, and use to create jsdata objects
 * @param {Object} options - constructor paramaters for '@bingads-webui-clientcenter/restful-service'
 * @param {string} rootUrl - url of root CC server
 * @param {Array} resourceNames - array of string jsData resource names like "FeatureAdoptionCoupon" to filter on
 * @return {Object} - jsdata rest service, and jsdata rest store
 */
function GetJsDataInfo(options) {
  let rootUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let resourceNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const restfulService = new _restfulService.default(options);
  const jsDataRestStore = new _jsDataRest.JsDataRestStore({
    restfulService
  });
  const cleanedRootUrl = (0, _urijs.default)(rootUrl).path('').toString();
  const selectedResources = resourceNames && resourceNames.length > 0 ? _underscore.default.pick(_staticResource.staticResourceConfig, resourceNames) : _staticResource.staticResourceConfig;

  _underscore.default.each(selectedResources, (config, name) => jsDataRestStore.defineRestResource(name, _objectSpread(_objectSpread({}, config), {}, {
    uriPath: (0, _urlUtil.join)(cleanedRootUrl, config.uriPath)
  })));

  const jsDataCcRest = jsDataRestStore.definitions;
  return {
    jsDataCcRest,
    jsDataRestStore
  };
}

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__224__;

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__225__;

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__226__;

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticResourceConfig = void 0;
const staticResourceConfig = {
  Account: {
    uriPath: '/cc/API/Account'
  },
  AccountBackupIOConfig: {
    uriPath: '/cc/API/InsertionOrder/AccountBackupIOConfig',
    primaryKey: 'AccountId'
  },
  AccountBudgetCenterInformation: {
    uriPath: '/cc/API/BudgetCenter/AccountBudgetCenterInformation'
  },
  AccountFeatureSet: {
    uriPath: '/cc/API/Account/AccountFeatureSet',
    primaryKey: 'accountId'
  },
  AccountFeatureEnabled: {
    uriPath: '/cc/API/Account/AccountFeatureEnabled',
    primaryKey: 'pilot'
  },
  AccountsFetchUnderTheSameABL: {
    uriPath: '/cc/API/Account/FetchAccountsUnderTheSameABL'
  },
  AccountIOAutoApproval: {
    uriPath: '/cc/InsertionOrder/AccountIOAutoApproval',
    primaryKey: 'AccountId'
  },
  AccountIOForecastingDailySpend: {
    uriPath: '/cc/API/InsertionOrder/InsertionOrderForecastingDailySpend'
  },
  AccountsInfoForAgency: {
    uriPath: '/cc/Agency/AccountsInfoForAgency',
    primaryKey: 'AccountId'
  },
  AccountAddOnBehalfOfAgencyContext: {
    uriPath: '/cc/Customers/AccountAddOnBehalfOfAgencyContext',
    primaryKey: 'AccountId'
  },
  AccountFundingInfo: {
    uriPath: '/cc/API/PaymentUtility/AccountFundingInfo',
    primaryKey: 'AccountId'
  },
  AccountIdentityVerification: {
    uriPath: '/cc/API/AccountIdentityVerification',
    primaryKey: 'accountId'
  },
  AccountIdentityVerificationInfo: {
    uriPath: '/cc/API/AccountIdentityVerification/Info',
    primaryKey: 'accountId'
  },
  AccountIdentityVerificationOnfidoToken: {
    uriPath: '/cc/API/AccountIdentityVerification/OnfidoToken',
    primaryKey: 'accountId'
  },
  AccountIdentityVerificationRetriggerBusinessVerification: {
    uriPath: '/cc/API/AccountIdentityVerification/RetriggerBusinessVerification'
  },
  AccountIdentityVerificationStateOverride: {
    uriPath: '/cc/API/AccountIdentityVerification/StateOverride'
  },
  AccountIdentityVerificationHoldOverride: {
    uriPath: '/cc/API/AccountIdentityVerification/HoldOverride'
  },
  AccountLevelAPContact: {
    uriPath: '/cc/API/Billing/AccountLevelAPContact',
    primaryKey: 'cid'
  },
  AccountMap: {
    uriPath: 'cc/API/Customer/AccountMap',
    primaryKey: 'rcid'
  },
  // TODO: Used in Create Account Step 3. This API should be split up and the server logic moved to client-side.
  AccountPaymentInformation: {
    uriPath: '/cc/Account/PaymentInformation'
  },
  AccountReparentingJobLoad: {
    uriPath: '/cc/API/Reparenting/JobLoad'
  },
  AccountReparentingLoadAccounts: {
    uriPath: '/cc/API/Reparenting/LoadAccounts'
  },
  AccountReparentingJobSubmit: {
    uriPath: '/cc/API/Reparenting/JobSubmit'
  },
  AccountReparentingJobAdd: {
    uriPath: '/cc/API/Reparenting/JobAdd'
  },
  AccountReparentingJobUpdate: {
    uriPath: '/cc/API/Reparenting/JobUpdate'
  },
  AccountReparentingValidateAccounts: {
    uriPath: '/cc/API/Reparenting/ValidateAccounts'
  },
  AccountReparentingValidateTargetCustomer: {
    uriPath: '/cc/API/Reparenting/ValidateTargetCustomer'
  },
  AccountReparentingValidateLinkInfo: {
    uriPath: '/cc/API/Reparenting/ValidateLinkInfo'
  },
  AccountReparentingValidateBillingInfo: {
    uriPath: '/cc/API/Reparenting/ValidateBillingInfo'
  },
  AccountReparentingFullValidate: {
    uriPath: '/cc/API/Reparenting/FullValidate'
  },
  AddressLoadCountry: {
    uriPath: '/cc/Address/LoadCountry'
  },
  AdjustmentDocument: {
    uriPath: '/cc/Adjustments/AdjustmentDocument',
    primaryKey: 'DocumentId'
  },
  AdjustmentNewAdjustment: {
    uriPath: '/cc/Adjustments/NewAdjustment',
    primaryKey: 'Id'
  },
  AgencyLinkRequest: {
    uriPath: '/cc/API/Linking/AgencyLinkRequest'
  },
  AgencyRequest: {
    uriPath: '/cc/Agency/Requests'
  },
  AgencyRequestBulkAction: {
    uriPath: '/cc/Agency/BulkAction',
    primaryKey: 'cid'
  },
  AgencyLinkedCustomers: {
    uriPath: '/cc/Customers/AgencyLinkedCustomers'
  },
  AncestorHierarchyPath: {
    uriPath: '/cc/Customers/AncestorHierarchyPath'
  },
  AssociateAndRedeemCoupon: {
    uriPath: '/cc/API/Coupon/smartautocoupon'
  },
  AssociateCoupon: {
    uriPath: '/cc/API/Coupon/AssociateCoupon'
  },
  BAARecommendations: {
    uriPath: '/cc/API/Recommendations/BAARecommendations'
  },
  Balance: {
    uriPath: '/cc/API/Billing/Balance',
    primaryKey: 'AccountId'
  },
  BillingGroup: {
    uriPath: '/cc/API/BillingGroup'
  },
  BillingGroupAccount: {
    uriPath: '/cc/API/BillingGroup/BillingGroupAccount',
    primaryKey: 'AccountId'
  },
  BillingSPABatchDownload: {
    uriPath: '/cc/Billing/SPABatchDownload'
  },
  BillingStatements: {
    uriPath: '/cc/API/Billing/BillingStatements',
    primaryKey: 'BillingDocumentId'
  },
  BillingSummary: {
    uriPath: '/cc/API/Billing/BillingSummary'
  },
  BillingSummaryForAccounts: {
    uriPath: '/cc/API/Billing/BillingSummaryForAccount'
  },
  BillingSettings: {
    uriPath: '/cc/Billing/BillingSettings',
    primaryKey: 'cid'
  },
  BillingSettingsUser: {
    uriPath: '/cc/Billing/BillingSettingsUser',
    primaryKey: 'cid'
  },
  BillingSettingsAddress: {
    uriPath: '/cc/Billing/BillingSettingsAddress',
    primaryKey: 'Id'
  },
  BillingSettingsUpdate: {
    uriPath: '/cc/Billing/BillingSettingsUpdate'
  },

  /* This BillingTile is restricted to be only used in BillingGrid SPA feature.
    After move billing tile to SPA this part will be removed.
  */
  BillingTile: {
    uriPath: '/cc/Billing/BillingTile'
  },
  BillNow: {
    uriPath: '/cc/API/Billing/BillNow'
  },
  BillNowForMca: {
    uriPath: '/cc/API/Billing/BillNowForMca'
  },
  BudgetInsightsAndAlerts: {
    uriPath: '/cc/API/BudgetCenter/BudgetInsightsAndAlerts'
  },
  BulkCreateInsertionOrderViewData: {
    uriPath: '/cc/InsertionOrder/BulkCreateInsertionOrderViewData',
    primaryKey: 'CustomerId'
  },
  BulkCreateInsertionOrder: {
    uriPath: '/cc/insertionOrder/CreateInsertionOrders'
  },
  BulkCustomerLinkJob: {
    uriPath: '/cc/Agency/BulkCustomerLinkJob',
    primaryKey: 'cid'
  },
  BulkEstimateTaxes: {
    uriPath: '/cc/API/Billing/BulkEstimateTaxes',
    primaryKey: 'AccountId'
  },
  BulkGetPrimaryContacts: {
    uriPath: '/cc/accounts/BulkGetPrimaryContacts'
  },
  BulkLinkingCustomerInfo: {
    uriPath: '/cc/Agency/BulkLinkingCustomerInfo',
    primaryKey: 'cid'
  },
  BulkLinkJob: {
    uriPath: '/cc/Agency/BulkLinkJob',
    primaryKey: 'cid'
  },
  BulkLinkJobUpdate: {
    uriPath: '/cc/Agency/BulkLinkJobUpdate',
    primaryKey: 'cid'
  },
  BulkPrepayPaymentParams: {
    uriPath: '/cc/Payment/BulkPrepayPaymentParams',
    primaryKey: 'cid'
  },
  BulkUpdatePrimaryContacts: {
    uriPath: '/cc/account/BulkUpdatePrimaryContacts'
  },
  BusinessAddressLoadCountry: {
    uriPath: '/cc/BusinessAddress/LoadCountryData' // This endpoint is deprecated. Please use DomainDataCountry

  },
  CampaignBudgetCenterInformation: {
    uriPath: '/cc/API/BudgetCenter/CampaignBudgetCenterInformation'
  },
  CampaignBudgetSummaryGrid: {
    uriPath: '/cc/API/BudgetCenter/CampaignBudgetSummaryGrid',
    primaryKey: 'CampaignId'
  },
  CampaignPerformanceBudget: {
    uriPath: '/cc/API/BudgetCenter/CampaignPerformanceBudget',
    primaryKey: 'CampaignId'
  },
  CanTriggerFCAVerification: {
    uriPath: '/cc/API/UKFCAVerification/CanTriggerFCAVerification',
    primaryKey: 'accountId'
  },
  CheckBillingGroupNameAvailability: {
    uriPath: '/cc/API/BillingGroup/CheckBillingGroupNameAvailability'
  },
  CleanDomain: {
    uriPath: '/cc/API/UKFCAVerification/CleanDomain',
    primaryKey: 'RawDomain'
  },
  ClearBalance: {
    uriPath: '/ClearBalance/ClearAccountBalance',
    primaryKey: 'accountId'
  },
  CountryCurrenciesMapping: {
    uriPath: '/cc/API/Currency/CountryCurrenciesMapping',
    primaryKey: 'country'
  },
  CountryTaxTypesMapping: {
    uriPath: '/cc/API/Country/CountryTaxTypesMapping'
  },
  CountryMapping: {
    uriPath: '/cc/API/Country'
  },
  Coupon: {
    uriPath: '/cc/API/Coupon'
  },
  CountryTimeZonesMapping: {
    uriPath: '/cc/API/TimeZone/GetTimeZonesPerCountry'
  },
  // For CCUI
  CouponRedemptionsAndAssociations: {
    uriPath: '/cc/API/Coupon/CouponRedemptionsAndAssociations',
    primaryKey: 'accountId'
  },
  ChannelPartnerPaymentContext: {
    uriPath: '/cc/API/PaymentInstrument/ChannelPartnerPaymentContext'
  },
  CNAccountVerification: {
    uriPath: '/cc/API/CNVerification/AccountVerification',
    primaryKey: 'id'
  },
  CNAccountVerificationSummary: {
    uriPath: '/cc/API/CNVerification/AccountVerificationSummary',
    primaryKey: 'accountId'
  },
  CNVerificationGridData: {
    uriPath: '/cc/API/CNVerification/QualificationList',
    primaryKey: 'QualificationId'
  },
  CNVerificationIndustryList: {
    uriPath: '/cc/API/CNVerification/IndustryList',
    primaryKey: 'aid'
  },
  CNVerificationQualification: {
    uriPath: '/cc/API/CNVerification/Qualification',
    primaryKey: 'QualificationId'
  },
  // This is the API used for create account. It returns currencies based on CID + Country Code.
  // The primary key is currently a string like 'query-71-0'. It should probably be changed to currencyId.
  Currencies: {
    uriPath: '/cc/Account/Currencies',
    primaryKey: 'Id'
  },
  // This is the API used by OBO. It returns currencies based on Country Code only.
  // It can probably be merged with Currencies (e.g. "Currency.findAll({ countryCode: 'US' })").
  CurrenciesByCountry: {
    uriPath: '/cc/Account/CurrenciesByCountry',
    primaryKey: 'Id'
  },
  // Not sure if this API is used. It is an extended version of Currencies.
  // It returns a list of currencies with their allowed countries, by CID.
  CurrencyCountriesMapping: {
    uriPath: '/cc/API/Currency/CurrencyCountriesMapping',
    primaryKey: 'currency'
  },
  CurrencyExchangeRate: {
    uriPath: '/cc/API/Currency/ExchangeRate'
  },
  Customer: {
    uriPath: '/cc/API/Customer'
  },
  CustomerAccess: {
    uriPath: '/cc/Customers/CustomerAccess',
    primaryKey: 'UserId'
  },
  CustomerAccountSignupOnBehalfOf: {
    uriPath: '/cc/Customers/CustomerAccountSignupOnBehalfOf',
    primaryKey: 'CustomerId'
  },
  CustomerAccountSignupOnBehalfOfAgencyContext: {
    uriPath: '/cc/Customers/CustomerAccountSignupOnBehalfOfAgencyContext',
    primaryKey: 'CustomerId'
  },
  CustomerAddress: {
    uriPath: '/cc/API/Customer/Address',
    primaryKey: 'Id'
  },
  CustomerAddresses: {
    uriPath: '/cc/BusinessAddress/CustomerAddresses' // This endpoint is deprecated. Please use CustomerAddress

  },
  CustomerFeatureDetail: {
    uriPath: '/cc/API/Customer/CustomerFeatureDetail',
    primaryKey: 'customerId'
  },
  CustomerFeatureEnabled: {
    uriPath: '/cc/API/Customer/CustomerFeatureEnabled',
    primaryKey: 'customerId'
  },
  CustomerFeatureEnabledSet: {
    uriPath: '/cc/API/Customer/CustomerFeatureEnabledSet',
    primaryKey: 'customerId'
  },
  CustomerHierarchy: {
    uriPath: '/cc/Customers/SearchCustomerHierarchy'
  },
  CustomerInfo: {
    uriPath: '/cc/Customers/CustomerInfo',
    primaryKey: 'Id'
  },
  CustomerLinkPermission: {
    uriPath: '/cc/Agency/CustomerLinkPermissionUpdate',
    primaryKey: 'cid'
  },
  CustomerProfile: {
    uriPath: '/cc/API/Customer/Profile',
    primaryKey: 'CustomerId'
  },
  DailyRemainingCreditLimit: {
    uriPath: '/cc/API/Account/DailyRemainingCreditLimit'
  },
  DeleteCtpPI: {
    uriPath: '/cc/API/PaymentInstrument/DeleteCtpPI'
  },
  DeletePI: {
    uriPath: '/cc/API/PaymentInstrument/DeletePI'
  },
  DeleteFCAVerification: {
    uriPath: '/cc/API/UKFCAVerification/DeleteFCAVerification',
    primaryKey: 'AccountId'
  },
  DelinkAccountRequest: {
    uriPath: '/cc/agency/CreateDelinkRequest',
    primaryKey: 'Message'
  },
  DomainDataAdjustmentReason: {
    uriPath: '/cc/API/DomainData/AdjustmentReasonMapping'
  },
  DomainDataCountry: {
    uriPath: '/cc/API/DomainData/CountryMapping',
    primaryKey: 'Id'
  },
  // This is just a list of currency information. No CID filtering included.
  DomainDataCurrency: {
    uriPath: '/cc/API/DomainData/CurrencyMapping',
    primaryKey: 'Id'
  },
  DomainDataEmailFreeHostDomain: {
    uriPath: '/cc/API/DomainData/EmailFreeHostDomain'
  },
  DomainDataIndustry: {
    uriPath: '/cc/API/DomainData/IndustryMapping',
    primaryKey: 'Code'
  },
  DomainDataLanguage: {
    uriPath: '/cc/API/DomainData/LanguageMapping',
    primaryKey: 'Code'
  },
  DomainDataBillingLanguage: {
    uriPath: '/cc/API/DomainData/BillingLanguageMapping',
    primaryKey: 'Key'
  },
  DomainDataGeography: {
    uriPath: '/cc/API/DomainData/LocalizedMappingCountry',
    primaryKey: 'Id'
  },
  DomainDataSubGeography: {
    uriPath: '/cc/API/DomainData/LocalizedMappingSubGeography'
  },
  DomainDataTimeZone: {
    uriPath: '/cc/API/DomainData/TimeZoneMapping',
    primaryKey: 'Name'
  },
  DomainDataCountryCodeCompanyCode: {
    uriPath: '/cc/API/DomainData/CountryCodeCompanyCodeMapping',
    primaryKey: 'Key'
  },
  EditUser: {
    uriPath: '/cc/API/User/EditUser'
  },
  EmailTokenValidation: {
    uriPath: '/cc/API/EmailTokenValidation',
    primaryKey: 'RequestId'
  },
  EstimateTaxes: {
    uriPath: '/cc/API/Billing/EstimateTaxes' // This endpoint is deprecated. Please use EstimateTaxesAllPayments

  },
  EstimateTaxesAllPayments: {
    uriPath: '/cc/API/Billing/EstimateTaxesAllPayments'
  },
  ExpertAccount: {
    uriPath: '/cc/API/Account/ExpertAccount',
    primaryKey: 'AccountId'
  },
  ExportAccountTransferSummary: {
    uriPath: '/cc/API/Reparenting/RenderAccountTransferSummaryExcel'
  },
  // The primary key is currently a string like '<accountId>-<featureId>'
  // This is so it can be fetched without knowing the current promotionId
  // account Id is included in the key because different accounts could have different promotions for a feature
  FeatureAdoptionCoupon: {
    uriPath: '/cc/API/Coupon/FeatureAdoptionCouponAdoptions',
    primaryKey: 'id'
  },
  FraudCustomerInfo: {
    uriPath: '/cc/API/FraudAppeal/FraudCustomerInfo'
  },
  FraudCustomerOptInAiv: {
    uriPath: '/cc/API/FraudAppeal/FraudCustomerOptInAiv'
  },
  FraudCustomerVerificationInfo: {
    uriPath: '/cc/API/FraudAppeal/FraudCustomerVerificationInfo'
  },
  GetCouponDetails: {
    uriPath: '/cc/API/Coupon/GetCouponDetails'
  },
  // For MCA
  GetCouponRedemptionsAndAssociations: {
    uriPath: '/cc/API/Coupon/GetCouponRedemptionsAndAssociations'
  },
  GetCouponStringForSignup: {
    uriPath: '/cc/API/Coupon/GetCouponStringForSignup'
  },
  GetCouponValidForCustomerWebsite: {
    uriPath: '/cc/API/Coupon/GetCouponValidForCustomerWebsite',
    primaryKey: 'websiteURL'
  },
  GetCustomers: {
    uriPath: '/cc/Customers/GetCustomers',
    primaryKey: 'userId'
  },
  GetPrimaryContacts: {
    uriPath: '/cc/API/User/PrimaryContacts'
  },
  HierarchyCustomersAccounts: {
    uriPath: '/cc/API/Hierarchy'
  },
  HierarchyLinkRequest: {
    uriPath: '/cc/API/Linking/HierarchyLinkRequest'
  },
  IOImportHistory: {
    uriPath: '/cc/InsertionOrder/IOImportHistory',
    primaryKey: 'ImportId'
  },
  IOImportSummary: {
    uriPath: '/cc/InsertionOrder/ImportSummary',
    primaryKey: 'entities'
  },
  IOImportApplyOrCancel: {
    uriPath: '/cc/InsertionOrder/ApplyOrCancelBulkIOImport',
    primaryKey: 'ImportId'
  },
  IndiaEInvoicingGenerationValidation: {
    uriPath: '/cc/API/Account/ValidateIndiaEInvoicingGeneration',
    primaryKey: 'accountId'
  },
  InsertionOrdersGridData: {
    uriPath: '/cc/InsertionOrder/InsertionOrdersGridData',
    primaryKey: 'InsertionOrderId'
  },
  InsertionOrdersGridColumnChooserData: {
    uriPath: '/cc/InsertionOrder/InsertionOrdersGridColumnChooserData'
  },
  InsertionOrdersGridFilterData: {
    uriPath: '/cc/InsertionOrder/InsertionOrdersGridFilterData'
  },
  InsertionOrdersMenuData: {
    uriPath: '/cc/InsertionOrder/InsertionOrdersMenuData'
  },
  InsertionOrderPermission: {
    uriPath: '/cc/API/InsertionOrder/InsertionOrderPermission'
  },
  InsertionOrder: {
    uriPath: '/cc/API/InsertionOrder'
  },
  InviteUser: {
    uriPath: '/cc/API/User/InviteUser'
  },
  LoadBillingGroupCandidates: {
    uriPath: '/cc/API/BillingGroup/LoadBillingGroupCandidates'
  },
  LoadUngroupedAccounts: {
    uriPath: '/cc/API/BillingGroup/LoadUngroupedAccounts'
  },
  LinkRequest: {
    uriPath: '/cc/API/Linking/LinkRequest'
  },
  ManagersModel: {
    uriPath: '/cc/API/Linking/Managers',
    primaryKey: 'cid'
  },
  MandateAgreementRequired: {
    uriPath: '/cc/API/MandateAgreementRequired',
    primaryKey: 'customerId'
  },
  McaPaymentContexts: {
    uriPath: '/cc/API/PaymentInstrument/McaPaymentContext'
  },
  MultiUserAuthorize: {
    uriPath: '/cc/API/User/MultiUserAuthorize',
    primaryKey: 'cid'
  },
  MultiUserCustomer: {
    uriPath: '/cc/Customers/MultiUserCustomer'
  },
  NavbarTab: {
    uriPath: '/cc/Tabs/NavbarTab'
  },
  OfflinePaymentInstructions: {
    uriPath: '/cc/Payment/OfflinePaymentInstructions'
  },
  PaymentInstrument: {
    uriPath: '/cc/API/PaymentInstrument',
    primaryKey: 'Id'
  },
  PaymentOptions: {
    uriPath: '/cc/API/PaymentInstrument/PaymentOptions'
  },
  PaymentSettingSwitch: {
    uriPath: '/cc/API/PaymentSettingSwitch'
  },
  PendingBillToChangeLight: {
    uriPath: '/cc/API/Billing/PendingBillToChangeLight',
    primaryKey: 'AccountId'
  },
  PermissionAccount: {
    uriPath: '/cc/API/Permission/Account'
  },
  PermissionCustomer: {
    uriPath: '/cc/API/Permission/Customer'
  },
  Person: {
    uriPath: '/cc/Customers/Person',
    primaryKey: 'PersonId'
  },
  PersonHistory: {
    uriPath: '/cc/Customers/PersonHistory'
  },
  PilotFeatures: {
    uriPath: '/cc/API/Customer/PilotFeatures'
  },
  PotentialBillingGroups: {
    uriPath: '/cc/API/BillingGroup/PotentialBillingGroups'
  },
  PrimaryContacts: {
    uriPath: '/cc/Users/PrimaryContacts'
  },
  Rebill: {
    uriPath: '/cc/API/Rebill'
  },
  RebillDocumentInfo: {
    uriPath: '/cc/Rebill/DocumentInfo',
    primaryKey: 'DocumentId'
  },
  Recommendation: {
    uriPath: '/cc/API/Notifications/Recommendation'
  },
  RecurringInsertionOrder: {
    uriPath: '/cc/InsertionOrder/RecurringInsertionOrder',
    primaryKey: 'SeriesId'
  },
  RecurringInsertionOrderViewData: {
    uriPath: '/cc/InsertionOrder/RecurringInsertionOrderViewData',
    primaryKey: 'CustomerId'
  },
  RequestDetailsModel: {
    uriPath: '/cc/Agency/RequestDetailsModel',
    primaryKey: 'id'
  },
  ResendAPContactValidation: {
    uriPath: '/cc/Billing/ResendAPContactValidation'
  },
  RiskControl: {
    uriPath: '/cc/API/PaymentUtility/RiskControl',
    primaryKey: 'AccountId'
  },
  SAPApplication: {
    uriPath: '/cc/API/PaymentInstrument/SAPApplication',
    primaryKey: 'SAPApplicationId'
  },
  SAPApplicationLight: {
    uriPath: '/cc/API/PaymentInstrument/SAPApplicationLight',
    primaryKey: 'SAPApplicationId'
  },
  SAPHighestMonthlySpend: {
    uriPath: '/cc/API/PaymentInstrument/SAPHighestMonthlySpend',
    primaryKey: 'SAPId'
  },
  SAPLightInfo: {
    uriPath: '/cc/API/PaymentInstrument/SAPLightInfo',
    primaryKey: 'invoiceId'
  },
  SaveCouponStringForSignup: {
    uriPath: '/cc/API/Coupon/SaveCouponStringForSignup',
    primaryKey: 'couponString'
  },
  SearchAccountMap: {
    uriPath: 'cc/API/Customer/SearchAccountMap'
  },
  ServiceLevel: {
    uriPath: '/cc/API/Customer/ServiceLevel'
  },
  SetFCADomainStatus: {
    uriPath: '/cc/API/UKFCAVerification/SetFCADomainStatus'
  },
  SettingsEmailNotification: {
    uriPath: '/cc/Settings/EmailNotificationSettings',
    primaryKey: 'cid'
  },
  SettingsEmailNotificationCategory: {
    uriPath: '/cc/Settings/EmailNotificationCategorySettings',
    primaryKey: 'tuid'
  },
  SettingsUserPreference: {
    uriPath: '/cc/Settings/UserPreferences',
    primaryKey: 'AccountId'
  },
  ShowLightBox: {
    uriPath: '/cc/Notifications/ShowLightBox',
    primaryKey: 'cid'
  },
  SignupAggreementOptions: {
    uriPath: '/Signup/AggreementOptions',
    primaryKey: 'countryCode'
  },
  SmartSignupAggreementOptions: {
    uriPath: '/Smart/Signup/AggreementOptions',
    primaryKey: 'countryCode'
  },
  SmartAccountStatus: {
    uriPath: '/cc/API/Customer/SmartAccountStatus',
    primaryKey: 'customerId'
  },
  SPAGetPaymentStatusAlerts: {
    uriPath: '/cc/Billing/SPAGetPaymentStatusAlerts',
    primaryKey: 'accountError'
  },
  StatusNotification: {
    uriPath: '/cc/Notifications/StatusNotifications'
  },
  SubmitBulkUnlinkAccounts: {
    uriPath: '/cc/managers/SubmitBulkUnlinkAccounts',
    primaryKey: 'ResultType'
  },
  SwitchPaymentSetting: {
    uriPath: '/BulkPaymentSettingSwitch/SwitchPaymentSetting',
    primaryKey: 'accountId'
  },
  TopUp: {
    uriPath: '/cc/Payment/TopUp'
  },
  TopUpLimit: {
    uriPath: '/cc/API/PaymentUtility/TopUpLimit'
  },
  TradeScreeningAccountEntity: {
    uriPath: '/cc/API/TradeScreeningTransformation/GridDataAccountEntity',
    primaryKey: 'Id'
  },
  TradeScreeningCustomerEntity: {
    uriPath: '/cc/API/TradeScreeningTransformation/GridDataCustomerEntity',
    primaryKey: 'Id'
  },
  TradeScreeningUserEntity: {
    uriPath: '/cc/API/TradeScreeningTransformation/GridDataUserEntity',
    primaryKey: 'Id'
  },
  TransactionHistory: {
    uriPath: '/cc/API/Billing/TransactionHistory'
  },
  UCPOfflineRefund: {
    uriPath: '/cc/API/UCPOfflineRefund'
  },
  UKFCAVerification: {
    uriPath: '/cc/API/UKFCAVerification',
    primaryKey: 'AccountId'
  },
  UnifiedQueueNotification: {
    uriPath: '/cc/API/Notifications/UnifiedQueueNotification'
  },
  UnifiedSmartAccountStatus: {
    uriPath: '/cc/API/Customer/UnifiedSmartAccountStatus'
  },
  UpdateAccountsInBillingGroup: {
    uriPath: '/cc/BillingGroup/UpdateAccountsInBillingGroup'
  },
  User: {
    uriPath: '/cc/API/User'
  },
  UserRole: {
    uriPath: '/cc/API/User/UserRole'
  },
  UserPreference: {
    uriPath: '/cc/API/Preference/UserPreference',
    primaryKey: 'upkey'
  },
  ValidateCustomerNumbersForLinking: {
    uriPath: '/cc/Agency/ValidateCustomerNumbersForLinking',
    primaryKey: 'CustomerId'
  },
  VerifyBusinessAddress: {
    uriPath: '/cc/API/Address/VerifyBusinessAddress'
  },
  VerifyCustomerSpendRequirement: {
    uriPath: '/cc/API/Customer/VerifyCustomerSpendRequirement'
  },
  VerifyEmailTokenValidation: {
    uriPath: '/cc/API/EmailTokenValidation/VerifyEmailTokenValidation',
    primaryKey: 'accountId'
  },
  VerifySAPCustomerUniqueness: {
    uriPath: '/cc/API/PaymentInstrument/VerifySAPCustomerUniqueness'
  },
  VerifyTaxInformation: {
    uriPath: '/cc/API/Address/VerifyTaxInformation'
  },
  YahooToken: {
    uriPath: '/TokenExchange/Yahoo',
    primaryKey: 'token'
  }
};
exports.staticResourceConfig = staticResourceConfig;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshJsDataCache = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _bluebird = _interopRequireDefault(__webpack_require__(16));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const preloadJsDataCache = _ref => {
  let {
    jsData,
    cid,
    aid
  } = _ref;
  const preloadList = [...(cid ? [jsData.Customer.find(cid)] : []), ...(aid ? [jsData.Account.find(aid)] : [])];
  return _bluebird.default.all(preloadList);
};
/**
 * Description of the function
 * @name PreloadCallback
 * @function
 * @param {object} options - options
 * @param {object} options.jsData - jsData object
 * @param {number|string} [options.cid] - customer id
 * @param {number|string} [options.aid] - account id
*/

/**
 * Clear the specified entities' jsData cache, then immediately preload some entities.
 * This function is designed for clearing dirty cache after entity update.
 * @function
 * @param {object} options - options
 * @param {object} options.jsData - jsData object
 * @param {number|string} [options.cid] - customer id to preload
 * @param {number|string} [options.aid] - account id to preload
 * @param {string[]} [options.entitiesToClear=[]] - the specified entities to clear, for example ['Account', 'Customer']. empty means clear all entities.
 * @param {PreloadCallback} [options.preloadCallback=null] - the custom preload callback. If not specified, Account and Customer will be preloaded.
 * @returns {Promise} - The preload Promise, it will resolve { ready: true }
 */


const refreshJsDataCache = _ref2 => {
  let {
    jsData,
    cid,
    aid,
    entitiesToClear = [],
    preloadCallback = null
  } = _ref2;

  if (_underscore.default.isEmpty(entitiesToClear)) {
    // Clear the whole JsData store cache
    _underscore.default.each(jsData, entityObj => entityObj && entityObj.ejectAll());
  } else {
    // Clear the specified entities' cache as required
    _underscore.default.each(entitiesToClear, entity => jsData[entity] && jsData[entity].ejectAll());
  } // by default preload customer data and account data


  const preloadCallbackFunc = preloadCallback || preloadJsDataCache;
  return preloadCallbackFunc({
    jsData,
    cid,
    aid
  }).then(() => ({
    ready: true
  }));
};

exports.refreshJsDataCache = refreshJsDataCache;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ })

/******/ })});;
